import React from 'react';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

interface CustomTooltipProps {
    title: string; // Tooltip text
    children: React.ReactNode; // Element to wrap with the tooltip
    placement?: 'top' | 'bottom' | 'left' | 'right'; // Tooltip placement
    arrow?: boolean; // Whether to show an arrow
}

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white, // Arrow color
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black, // Tooltip background color
    },
}));

function CustomTooltip({ title, children, placement = 'bottom', arrow = true }: CustomTooltipProps): JSX.Element {
    return (
        <BootstrapTooltip title={title} placement={placement} arrow={arrow}>
            <div>{children}</div>
        </BootstrapTooltip>
    );
}

export default CustomTooltip;